const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-chord"),
    require("d3-shape"),
    require("d3-interpolate")
)

export function drawContent() {
    // console.clear()
    // For nested functions
    const obj = this

    const res = d3
        .chord()
        .padAngle(0.02) // padding between entities (black arc)
        .sortSubgroups(d3.descending)(this.matrix)

    const arcDef = d3
        .arc()
        .innerRadius(this.dimensions.arcInnerRadius)
        .outerRadius(this.dimensions.arcRadius)

    const arcs = d3
        .select("#arcs")
        .selectAll("path")
        .datum(res)
        .data(res.groups)

    arcs.exit()
        .attr("opacity", 0.5)
        .remove()

    arcs.enter()
        .append("path")
        .attr("class", "arc")
        .style("fill", this.colors.arc)
        .each(d => {
            this._current = d
        }) // store the initial angles
        .attr("d", arcDef)
        .on("mouseover", (d, i, node) => {
            arcOver(d, i, node, obj)
        })
        .on("mouseleave", (d, i, node) => {
            arcOut(d, i, node, obj)
        })
        .on("click", (d, i, node) => {
            arcClick(d, i, node, obj)
        })

    d3.selectAll(".arc")
        .transition()
        .duration(500)
        .ease(d3.easeCubicInOut)
        .style("fill", this.colors.arc)
        .style("stroke", this.colors.border)
        .attr("opacity", this.colors.arcOpacity)
        .attrTween("d", arcTween)

    function arcTween(a) {
        var i = d3.interpolate(this._current, a)
        this._current = i(0)
        return t => {
            return arcDef(i(t))
        }
    }

    // #### RIBBONS

    const ribbons = d3
        .select("#ribbons")
        .selectAll("path")
        .data(res)

    ribbons.exit().remove()

    ribbons
        .enter()
        .append("path")
        .attr("class", "ribbon")
        .attr("opacity", 0)
        .on("mouseover", (d, i, node) => {
            ribbonOver(d, i, node, obj)
        })
        .on("mouseleave", (d, i, node) => {
            ribbonOut(d, i, node, obj)
        })

    function ribbonOver(d, i, node) {
        if (obj.tagClicked < 0) {
            d3.select(node[i]).attr("opacity", 0.7)
        }

        if (
            obj.tagClicked < 0 ||
            (obj.tagClicked > 0 &&
                node[i].getAttribute("class") == "ribbon selected")
        ) {

            const tagCount = d3.select("#tagCount")
            const centerX = obj.dimensions.maxWidth/2 - tagCount.node().offsetWidth / 2
          
            const centerY =
                obj.dimensions.margin +
                obj.dimensions.height / 2 -
                +tagCount.node().offsetHeight / 2
            tagCount
                .style("opacity", 1)
                .style("transform", `translate(${centerX}px, ${centerY}px)`)
                .select("#tagCountText")
                .text(`${d.source.value} photos`)
        }
    }

    function ribbonOut(d, i, node, obj) {
        if (obj.tagClicked < 0) {
            d3.select(node[i]).attr("opacity", obj.colors.ribbonOpacity)
        }
        d3.select("#tagCount")
            .style("opacity", 0)
            .style("transform", `translate(-10000px, -10000px)`)
    }

    d3.selectAll(".ribbon")
        .transition()
        .delay(200)
        .ease(d3.easeCubicInOut)
        .attr("opacity", this.colors.ribbonOpacity)
        .attr("fill", this.colors.ribbon)
        .attr("d", d3.ribbon().radius(this.dimensions.ribbonRadius))

    // LABELS

    const labels = d3
        .select("#labels")
        .selectAll("text")
        .data(res.groups)

    labels.exit().remove()

    labels
        .enter()
        .append("text")
        .attr("class", "label")

    d3.selectAll(".label")
        .each(d => {
            d.angle = (d.startAngle + d.endAngle) / 2
        })
        .transition()
        .duration(500)
        .attr("transform", d => {
            const angle = (d.angle * 180) / Math.PI - 90
            const innerRotation = Number(d.angle) > Math.PI ? 180 : 0
            const translate =
                d.angle > Math.PI
                    ? this.dimensions.textRadius * -1
                    : this.dimensions.textRadius

            return `rotate(${angle + innerRotation}) translate(${translate})`
        })
        .style("text-anchor", d => {
            return d.angle > Math.PI ? "end" : null
        })
        .attr("class", "label")
        .text((d, i) => this.selectedTags[i])

    function arcOver(d, i, node) {
        d3.select(node[i]).attr("opacity", 0.7)
    }

    function arcOut(d, i, node, obj) {
        if (obj.tagClicked < 0) {
            obj.removeTagHighlight()
        }
    }

    function arcClick(d, i, node, obj) {
        obj.setTag(i)

        const tooltip = d3.select("#tooltip")
        const w = tooltip.node().offsetWidth
        const h = tooltip.node().offsetHeight

        let x =
            Math.cos(d.angle - Math.PI / 2) * (obj.dimensions.arcRadius - 10) +
            obj.dimensions.arcRadius +
            obj.dimensions.margin +
            37 -
            obj.dimensions.width / 2
        let y =
            Math.sin(d.angle - Math.PI / 2) * (obj.dimensions.arcRadius - 10) +
            obj.dimensions.arcRadius +
            obj.dimensions.margin * 2 +
            obj.dimensions.histogram

        tooltip
            .style("opacity", 1)
            .style("transform", `translate(${x - w / 2}px, ${y - h + 10}px)`)

        tooltip.select("#amount").text(`${obj.tagAmount[i][1]}`)
        tooltip.select("#tagName").text(`${obj.selectedTags[i]}`)
        tooltip
            .select(".view")
            .attr("data-index", d.index)
            .select("#amount")
            .text(`${obj.tagAmount[i][1]}`)

        d3.selectAll(".ribbon")
            .filter(d => {
                return d.source.index != i && d.target.index != i
            })
            .transition()
            .duration(500)
            .attr("opacity", 0)
            .attr("class", "ribbon")

        d3.selectAll(".ribbon")
            .filter(d => {
                return d.source.index == i || d.target.index == i
            })
            .transition()
            .duration(500)
            .attr("opacity", 0.7)
            .attr("class", "ribbon selected")
    }
}

export function updateContent() {
    this.drawContent()
}

export function hideToolTip() {
    this.tagClicked = -1
    d3.select("#tooltip")
        .style("opacity", 0)
        .style("transform", `translate(-10000px, -10000px)`)

    this.removeTagHighlight()
}

export function removeTagHighlight() {
    d3.selectAll(".arc").attr("opacity", this.colors.arcOpacity)
    d3.selectAll(".ribbon")
        .transition()
        .duration(300)
        .attr("opacity", this.colors.ribbonOpacity)
}

export function setTag(index) {
    this.tagClicked = index
    this.selectedTagName = this.selectedTags[index]
}

export default drawContent
